import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
const CardTypes = {
  NONE: '',
  AMEX: 'AX',
  DINERS: 'DC',
  DISCOVER: 'DI',
  JCB: 'JC',
  MASTER_CARD: 'MC',
  VISA: 'VI',
  VISA_COBRAND: 'VIC',
  UNION_PAY: 'UP'
};
const CardTypeImageUrls = [{
  cardType: CardTypes.VISA,
  imageUrlNo: '3'
}, {
  cardType: CardTypes.AMEX,
  imageUrlNo: '1'
}, {
  cardType: CardTypes.DINERS,
  imageUrlNo: '6'
}, {
  cardType: CardTypes.DISCOVER,
  imageUrlNo: '4'
}, {
  cardType: CardTypes.JCB,
  imageUrlNo: '7'
}, {
  cardType: CardTypes.MASTER_CARD,
  imageUrlNo: '2'
}, {
  cardType: CardTypes.VISA_COBRAND,
  imageUrlNo: '8'
}, {
  cardType: CardTypes.UNION_PAY,
  imageUrlNo: '5'
}];
const CardPattern = {
  SECURITY_CODE: /^[0-9]{3}$/,
  SECURITY_CODE_AMEX: /^[0-9]{4}$/,
  // Credit Card Type Validation Pattern
  AMEX: /^3[47][0-9]{13}$/,
  DINERS: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  DISCOVER: /^6(?:011\d{12}|5\d{14}|4[4-9]\d{13}|22(?:1(?:2[6-9]|[3-9]\d)|[2-8]\d{2}|9(?:[01]\d|2[0-5]))\d{10})$/,
  JCB: /^(?:2131|1800|35\d{3})\d{11}$/,
  MASTER: /^(2[2-7]|5[1-5])[0-9]{14}$/,
  VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
  REPEATING_CHARACTERS: /^(.)\1*$/,
  // all characters are the same
  VISA_COBRAND: /^4418379[46][0-9]{8}$/,
  // Regex for visa co brand
  UNION_PAY: /^62(?:1094|212[6-9]|21[3-9]\d|2[2-9]\d{2}|3[0-6]\d{2}|37[0-8]\d|379[0-6]|[4-6]\d{3}|8[2-8]\d{2})\d{10}$/
};
class CardTypePipe {
  transform(number) {
    if (!number) {
      return CardTypes.NONE;
    }
    let regex = new RegExp(CardPattern.VISA_COBRAND);
    if (number.match(regex) !== null) {
      return CardTypes.VISA_COBRAND;
    }
    regex = new RegExp(CardPattern.VISA);
    if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
      return CardTypes.VISA;
    }
    regex = new RegExp(CardPattern.MASTER);
    if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
      return CardTypes.MASTER_CARD;
    }
    regex = new RegExp(CardPattern.AMEX);
    if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
      return CardTypes.AMEX;
    }
    regex = new RegExp(CardPattern.UNION_PAY);
    if (number.match(regex) !== null) {
      return CardTypes.UNION_PAY;
    }
    regex = new RegExp(CardPattern.DISCOVER);
    if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
      return CardTypes.DISCOVER;
    }
    regex = new RegExp(CardPattern.DINERS);
    if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
      return CardTypes.DINERS;
    }
    regex = new RegExp(CardPattern.JCB);
    if (number.match(regex) !== null && this.luhnCheckCreditCard(number)) {
      return CardTypes.JCB;
    }
    return CardTypes.NONE;
  }
  luhnCheckCreditCard(num) {
    let digit, odd, sum, _i, _len;
    odd = true;
    sum = 0;
    const digits = (num + '').split('').reverse();
    for (_i = 0, _len = digits.length; _i < _len; _i++) {
      digit = digits[_i];
      digit = parseInt(digit, 10);
      if (odd = !odd) {
        digit *= 2;
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    return sum % 10 === 0;
  }
  static {
    this.ɵfac = function CardTypePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardTypePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cardType",
      type: CardTypePipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardTypePipe, [{
    type: Pipe,
    args: [{
      name: 'cardType',
      standalone: false
    }]
  }], null, null);
})();
class CardTypeModule {
  static {
    this.ɵfac = function CardTypeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardTypeModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CardTypeModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [CardTypePipe],
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardTypeModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [CardTypePipe],
      providers: [CardTypePipe],
      exports: [CardTypePipe]
    }]
  }], null, null);
})();

/*
 * Public API Surface of card-types
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardPattern, CardTypeImageUrls, CardTypeModule, CardTypePipe, CardTypes };
